import { Alert, Col, Row } from "antd";
import { useState } from "react";
import { DashboardStatCards } from "../domains/dashboard/components/DashboardStatCards";
import { NewProductsPerMonthChart } from "../domains/dashboard/components/NewProductsPerMonthChart";
import { RevenueDailyModal } from "../domains/dashboard/components/RevenueDailyModal";
import { RevenuePerMonthChart } from "../domains/dashboard/components/RevenuePerMonthChart";
import { useDashboardOverviewQuery } from "../domains/dashboard/hooks/useDashboardOverviewQuery";
import { useProductCreatedTimeseriesQuery } from "../domains/dashboard/hooks/useProductCreatedTimeseriesQuery";
import { useRevenueTimeseriesQuery } from "../domains/dashboard/hooks/useRevenueTimeseriesQuery";
import type { RevenueMarketFilter } from "../domains/dashboard/types";
import { isAdminOrSuperAdmin } from "utility/helper";

export const DashboardPage: React.FC = () => {
  const canViewRevenue = isAdminOrSuperAdmin();
  const [revenueMarket, setRevenueMarket] = useState<RevenueMarketFilter>(null);
  const [selectedMonthPeriod, setSelectedMonthPeriod] = useState<string | null>(
    null,
  );
  const overview = useDashboardOverviewQuery();
  const timeseries = useProductCreatedTimeseriesQuery(12);
  const revenue = useRevenueTimeseriesQuery(12, revenueMarket);

  const errorMessage =
    (overview.error instanceof Error && overview.error.message) ||
    (timeseries.error instanceof Error && timeseries.error.message) ||
    (canViewRevenue &&
      revenue.error instanceof Error &&
      revenue.error.message) ||
    undefined;

  return (
    <>
      {(overview.isError ||
        timeseries.isError ||
        (canViewRevenue && revenue.isError)) && (
        <Alert
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
          message="Kunde inte hämta dashboard-data"
          description={errorMessage}
        />
      )}

      <DashboardStatCards data={overview.data} loading={overview.isLoading} />

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <NewProductsPerMonthChart
            points={timeseries.data?.points}
            loading={timeseries.isLoading}
          />
        </Col>
        {canViewRevenue && (
          <Col span={24}>
            <RevenuePerMonthChart
              points={revenue.data?.points}
              loading={revenue.isLoading}
              market={revenueMarket}
              onMarketChange={setRevenueMarket}
              onMonthClick={setSelectedMonthPeriod}
            />
          </Col>
        )}
      </Row>

      {canViewRevenue && (
        <RevenueDailyModal
          open={selectedMonthPeriod != null}
          period={selectedMonthPeriod}
          market={revenueMarket}
          onClose={() => setSelectedMonthPeriod(null)}
        />
      )}
    </>
  );
};
